// extracted by mini-css-extract-plugin
export var alignDiscLeft = "q_qB d_fl d_bC d_dr";
export var alignLeft = "q_p6 d_fl d_bC d_dr";
export var alignDiscCenter = "q_qC d_fm d_bz d_ds";
export var alignCenter = "q_bL d_fm d_bz d_ds";
export var alignDiscRight = "q_qD d_fn d_bD d_dt";
export var alignRight = "q_p7 d_fn d_bD d_dt";
export var footerContainer = "q_qF d_dS d_bS";
export var footerContainerFull = "q_qG d_dQ d_bS";
export var footerHeader = "q_kc d_kc";
export var footerTextWrapper = "q_qH d_s";
export var footerDisclaimerWrapper = "q_kk d_kk d_cg";
export var badgeWrapper = "q_qJ d_s d_bw d_bL d_bB d_bF";
export var footerDisclaimerRight = "q_kl d_kl d_bw";
export var footerDisclaimerLeft = "q_km d_km d_bw";
export var verticalTop = "q_qK d_bw d_bF d_bK d_bH";
export var firstWide = "q_qL";
export var disclaimer = "q_qM";
export var socialDisclaimer = "q_qN";
export var left = "q_qP";
export var wide = "q_qQ d_cv";
export var right = "q_qR d_bG";
export var line = "q_fg d_fh d_cr";
export var badgeDisclaimer = "q_qS d_by d_bL d_bF";
export var badgeContainer = "q_qT d_bw d_bD d_bL";
export var badge = "q_qV";
export var padding = "q_qW d_c4";
export var end = "q_qX d_bD";
export var linkWrapper = "q_qY d_dx";
export var link = "q_m0 d_dx";
export var colWrapper = "q_qZ d_ct";
export var media = "q_q0 d_bt d_dv";
export var itemRight = "q_q1";
export var itemLeft = "q_q2";
export var itemCenter = "q_q3";
export var exceptionWeight = "q_q4 x_sl";